import React, {Component} from 'react'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend';
import {Link} from 'react-router-dom'
import {FormattedMessage, FormattedDate} from 'react-intl'
import StandardList from '../common/listing/list.component.jsx'
import SideBar from '../common/layout/sidebar.component.jsx'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import SalesToolsTabs from "../common/layout/tabs/salestools.component.jsx"
import Icon from "../common/icon/icon.component.jsx"

class RelationshipListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            rows: [],
            headers: [],
            searchKeywords: '',
            loading: false,
        }
        this.handleSearchChange = this.handleSearchChange.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        this.refreshSearch()
    }

    handleSearchChange(event) {
        const target = event.target;
        //TODO: replace url
        // history.replace({
        //     search: '?q=' + target.value,
        // })
        this.setState({
            searchKeywords: target.value
        }, () => {
            this.refreshSearch()
        })
    }

    refreshSearch() {
        this.setState({
            loading: true,
        })
        AppContext.getApiClient().get('/relationships').then(r => {
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
            })
        })

    }

    headers() {
        return [
            <FormattedMessage
                id="listing.relationships.list.headers.description_label"
                defaultMessage="Description"
            />,
            <FormattedMessage
                id="listing.relationships.list.headers.subject_label"
                defaultMessage="Subject"
            />,
            <FormattedMessage
                id="listing.relationships.list.headers.type_label"
                defaultMessage="Type"
            />,
            <FormattedMessage
                id="listing.relationships.list.headers.object_label"
                defaultMessage="Object"
            />,
            <FormattedMessage
                id="listing.products.list.headers.created_at_label"
                defaultMessage="Created at"
            />,
        ]
    }

    row(item) {
        return [
            <Link to={"/relationships/edit/" + item.id}>{item.attributes.description}</Link>,
            item.attributes.subjectProduct.attributes.title,
            item.attributes.type,
            item.attributes.objectProduct.attributes.title,
            <FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(item.attributes.createdAt)}/>,
        ]
    }


    render() {
        let list = <StandardList
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        }
        return (
            <div>
                <SalesToolsTabs/>
                <div className="row ui-has-modules py-1">
                    <div className="col-12 ui-module mb-0">
                        <div className="row mb-0 justify-content-end">
                            <div className="col-3 text-align-right ">
                                <Link to="/relationships/new" className="btn btn-primary">
                                    <Icon value={"plus-circle"}/>
                                    <FormattedMessage
                                        id="relationship.listing.add_relationship_btn"
                                        defaultMessage="Add relationship"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {list}
            </div>
        );
    }
}

export default RelationshipListing


// WEBPACK FOOTER //
// ./src/relationship/listing.component.jsx